export const SURVEY_LIBRARY_ENDPOINTS = {
  LIST: "/survey-manager/survey-library/list",
  CREATE: "/survey-manager/survey-library/create",
  GETSURVEYBYID: (id) => `/survey-manager/survey-library/${id}`,
  UPDATE: (id) => `/survey-manager/survey-library/${id}`,
  DELETE: (id) => `/survey-manager/survey-library/${id}`,
  CLOSE_SURVEY: (id) => `/survey-manager/survey-library/${id}/close`,
};
